module.exports = __webpack_public_path__ + "img/46_01.ce3e6d46.png";